import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="32" viewBox="-1 -1 44 34">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#8091A5"
      d="M31.4 12.8h-1.7l-.9 4.8h1.5c1 0 1.7-.2 2.3-.6.5-.4.9-1 1-1.9.2-.9.1-1.5-.2-1.8-.4-.4-1-.5-2-.5m-19.4 0h-1.7l-.9 4.8h1.5c1 0 1.7-.2 2.3-.6.6-.4.9-1 1-1.9.2-.9.1-1.5-.2-1.8-.4-.4-1-.5-2-.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#8091A5"
      d="M21 5.4C9.6 5.4.2 10.1.2 16c0 5.9 9.3 10.6 20.8 10.6 11.4 0 20.8-4.8 20.8-10.6 0-5.9-9.4-10.6-20.8-10.6zm-5.9 12.7c-.5.4-1 .8-1.6 1-.6.2-1.4.3-2.3.3H9l-.6 3.1H6L8.2 11H13c1.5 0 2.4.4 3.1 1.1.7.8.9 1.8.6 3.2-.1.6-.3 1-.5 1.5-.3.4-.6.9-1.1 1.3zm7.2 1.3l1-5.1c.1-.6.1-1-.1-1.2-.2-.2-.6-.4-1.2-.4h-2l-1.2 6.6h-2.4l2.2-11.5H21l-.6 3.1h2.2c1.4 0 2.4.2 2.9.7.5.5.7 1.3.4 2.4l-1 5.3h-2.6zM36 15.3c-.1.6-.3 1-.6 1.5-.3.4-.6.9-1 1.3-.5.4-1 .8-1.7 1-.6.2-1.4.3-2.3.3h-2.1l-.6 3.1h-2.4L27.5 11h4.8c1.5 0 2.4.4 3.1 1.1.7.7.9 1.8.6 3.2z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/language-php.es6.js